<template>
    <div>
        {{ $t('notification.taskModuleRulesEnabled', { 
            actor: $_.get(activity, 'actorUser.name'), 
            workflowTitle: $_.get(activity, 'payload.workflowTitle')
        }) }}
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskModuleRulesEnabled",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

